// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_22-d-"};


//////////////////
// WEBPACK FOOTER
// ./containers/Checkout/styles.scss
// module id = 765
// module chunks = 0